// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const CONDITION_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  CONDITION_MANDATORY: 'mandatory',
  CONDITION_CONTEXT_SENSITIVE: 'contextSensitive',
  CONDITION_DEACTIVATED: 'deactivated',
  CONDITION_DEACTIVATED_FOR_WORKSHEETS: 'deactivatedForWorksheets',
  CONDITION_HIDDEN: 'hidden',
  CONDITION_HIDDEN_FOR_WORKSHEETS: 'hiddenForWorksheets',
  CONDITION_ANIMATION_ALLOW: 'condition.animation.allow',
  CONDITION_ANIMATION_NUMBER_OF_FRAMES: 'condition.animation.numberOfFrames',
  TABLE_CONDITION_EXCLUDE_VALUES: 'excludeValues',
  TABLE_CONDITION_ALLOW_EXCLUDE_VALUES: 'allowExcludeValues',
  LIKE_CONDITION_FILTER_TYPE: 'filterType',
  LIKE_CONDITION_CASE_SENSITIVITY: 'caseSensitivity',
  LIKE_CONDITION_COMBINATION_TYPE: 'combinationType',
  CONDITION_MODE: 'mode',
  CONDITION_HINT: 'hint',
  TABLE_CONDITION_LIMIT: 'limit',
  VALUE_INTERVAL_CONDITION_LOWER_BOUNDARY_TYPE: 'lowerBoundaryIntervalLimitType',
  VALUE_INTERVAL_CONDITION_UPPER_BOUNDARY_TYPE: 'upperBoundaryIntervalLimitType',
  DATE_CONDITION_INTERVAL: 'isInterval',
  DATE_CONDITION_SLIDER_CUSTOM_START_DATE: 'sliderCustomStartDate',
  DATE_CONDITION_SLIDER_CUSTOM_END_DATE: 'sliderCustomEndDate',
  DATE_CONDITION_INTERVAL_UNIT: 'condition.date.intervalUnit',
  DATE_CONDITION_INTERVAL_LENGTH: 'condition.date.intervalLength',
  DATE_CONDITION_INTERVAL_OVERLAP_LENGTH: 'condition.date.overlapLength',
  DATE_CONDITION_DATA_INPUT_FILTER_MODE_ENABLED: 'condition.date.dataInputModeEnabled',
  DATE_CONDITION_STEPS_FILTER_MODE_ENABLED: 'condition.date.stepsModeEnabled',
  DATE_CONDITION_ACTIVE_FILTER_MODE: 'condition.date.filterMode',
  DATE_CONDITION_FORMAT: 'condition.date.format',
  DATE_CONDITION_FILTER_MODE_ENABLED: 'condition.date.filterModeEnabled',
  SPATIAL_CONDITION_RELATION: 'condition.spatial.relation'
} as const;

/** @see net/disy/cadenza/workbook/model/ConditionSettingsKey.java */
export type ConditionSettingsKey = keyof typeof CONDITION_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const ConditionSettingsKey = {
  values: Object.keys(CONDITION_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly ConditionSettingsKey[],
  toPersistenceKey: (value: ConditionSettingsKey) => CONDITION_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = ConditionSettingsKey.values.find(key => CONDITION_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No ConditionSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
